var React = require('react');

var factory = require('./factory.js');
var css = require('./module.scss');

/**
 * 使用方法：
 * Prompt.success('success');
 * Prompt.error('error');
 * Prompt.warn('warning');
 */

function BasePrompt(duration) {
    this.controller = factory("__caih_fireplug_prompt__", "caih-fireplug-prompt");
    this.list = [];
    this.timer = null;
    this.duration = duration;
}

BasePrompt.prototype.render = function(config) {
    this.controller.renderDialog({
        visible: 1,
        wrapClassName: 'fp-prompt',
        mask: config.mask,
        content: <ul className='fp-prompt-items'>
            {
                this.list.map(function(d, i) {
                    return <li key={d.id}>
                        <span className='fp-prompt-content'>
                            <i className={'fp-' + (d.icon || 'info') + '-icon'}></i>
                            <span className='fp-prompt-text'>{d.content}</span>
                        </span>
                    </li>;
                })
            }
        </ul>
    });
};


BasePrompt.prototype.add = function(item) {

    /* item:{
    	id:'',
    	content:'',
    	duration:duration
    } */
    if (!item) {
        return;
    }

    var id = item.id;
    this.list.push(item);

    this.render({
        mask: item.mask
    });

    if (item.duration != -1) {
        setTimeout(function() {
            removeItem(this.list, id);
            this.render({
                mask: this.list.length == 0 ? false : true
            });
        }.bind(this), item.duration || this.duration);
    }

    return {
        destroy: function() {
            removeItem(this.list, id);
            this.render({
                mask: this.list.length == 0 ? false : true
            });
        }.bind(this)
    };

};
function removeItem(arr, id) {
    var e = -1;
    for (var i = 0; i < arr.length; i++) {
        if (arr[i].id == id) {
            e = i;
            break;
        }

    }
    arr.splice(e, 1);
    return arr;
}

/*
function noPointerEvents (ele) {
    if(ele.addEventListener){
    	ele.attachEvent('mousemove',function(e){
    		this.style.display = 'none';
    		var event = e || window.event;
    		var x = event.pageX, y = event.pageY,under = document.elementFromPoint(x, y);
    		this.style.display = '';
    		event.stopPropagation();
        	event.preventDefault();
        	//未开发完成，需要新事件，然后触发
        	under.dispatchEvent();
    	});
    } else if(ele.attachEvent){
    	ele.attachEvent('onmousemove',function(e){
    		this.style.display = 'none';
    		var event = e || window.event;
    		var x = event.pageX, y = event.pageY,under = document.elementFromPoint(x, y);
    		this.style.display = '';
    		event.stopPropagation();
        	event.preventDefault();
        	under.mousemove();
    	});
    }
}

function getStyle(element, att){

    //特性侦测

    if(window.getComputedStyle){

        //优先使用W3C规范

        return window.getComputedStyle(element)[att];

    }else{

        //针对IE9以下兼容

        return element.currentStyle[att];

    }

}*/


var base = new BasePrompt(2000);

module.exports = {
    error: function(content, duration) {
        return base.add({
            id: parseInt(new Date().getTime() / 100000, 10) + '' + 100 * Math.random(),
            icon: 'error',
            content: content,
            duration: duration || 2000
        });
    },
    warn: function(content,duration) {
        return base.add({
            id: parseInt(new Date().getTime() / 100000, 10) + '' + 100 * Math.random(),
            icon: 'warn',
            content: content,
            duration: duration || 1500
        });
    },
    success: function(content, duration) {
        return base.add({
            id: parseInt(new Date().getTime() / 100000, 10) + '' + 100 * Math.random(),
            icon: 'success',
            content: content,
            duration: duration || 1500
        });
    },
    loading: function(content) {
        return base.add({
            id: parseInt(new Date().getTime() / 100000, 10) + '' + 100 * Math.random(),
            icon: 'loading',
            content: content || '正在加载，请稍后...',
            duration: -1,
            mask: true
        });
    }
};

/* var Prompt = React.createClass({
getInitialState:function(){
		return {
			viewState:0,//0为不展示，1为展示前准备,2为展示
			dialogState:false,
			time:3000
		};
	},
	componentWillReceiveProps:function(nextProps){
		if(this.props.config.isShow != nextProps.config.isShow){
			if(nextProps.config.isShow){
				this.show();
			}else{
				this.hide();
			}
		}
	},
	render: function() {
		var style;
		if(this.state.viewState==1){
			style={
				opacity:0
			}
		}else if(this.state.viewState==2){
			style={
				opacity:1
			}
		}else{
			style={
				opacity:0
			}
		}

		return <Dialog config={{
			mask:false,
			width:350,
			height:200,
			isShow:this.state.dialogState
		}}>
			<div className={css.prompt}>
				<span className={css.promptText} style={style}>
					{this.props.children}
				</span>
			</div>
		</Dialog>;
	},
	show:function(){

		this.setState({
			viewState:1,
			dialogState:true
		});

		if(this.sto){
			clearTimeout(this.sto);
		}

		setTimeout(function(){
			this.setState({
				viewState:2,
				dialogState:true
			});
		}.bind(this),50);
		this.sto = setTimeout(function(){
			if(this.props.config.hideCb){
				this.props.config.hideCb();
			}
		}.bind(this),this.props.time||this.state.time);
	},
	hide:function(){
		this.setState({
			viewState:0,
			dialogState:this.state.dialogState
		});

		if(this.stoHide){
			clearTimeout(this.stoHide);
		}

		this.stoHide = setTimeout(function(){
			this.setState({
				dialogState:false
			});
		}.bind(this),300);
	}
}); */



// WEBPACK FOOTER //
// ./component/dialog/prompt.js